import { CssUtil } from "../../utils/css-util";
import { ICssPropertiesObject } from "../../models/css-property";

export abstract class StyleManagerBase {

    protected constructor(protected readonly doc: Document) {}

    protected static ensureSiteDesignStyles(doc: Document): HTMLStyleElement {
        let commonStyles = doc.getElementById("pb-site-design-styles") as HTMLStyleElement;
        if (!commonStyles) {
            commonStyles = doc.createElement("style");
            commonStyles.id = "pb-site-design-styles";
            doc.head.appendChild(commonStyles);
        }

        commonStyles.setAttribute("data-layout-element", "");

        return commonStyles;
    }

    public flush(): void {
        // clenup empty styles
        const styles = this.doc.head.querySelectorAll("style");
        styles.forEach(s => {
            if (!s.id && !s.textContent) s.remove();
        });
    }

    public clearStyle(sheet: CSSStyleSheet, selector: string): void {
        const index = CssUtil.findRuleIndex(selector, sheet);
        if (index > -1) sheet.deleteRule(index);
    }

    public setRootCssVariablesObjectToStyleTag(styleTag: HTMLStyleElement, properties: ICssPropertiesObject): void {
        CssUtil.setRootVariablesInSheet(styleTag.sheet, properties);
        CssUtil.flushSheet(styleTag);
    }

    public abstract get CommonStyle(): HTMLStyleElement;

}
